export const avoidIfLoggedIn = ['/forgotpass', '/newaccount', '/login', '/account/reset']
export const preventRedirects = ['/autoactivation']
